import React from "react";
import Navbar from "./Navbar";
import Card from "./Card";
import logo from "./logo.png"
import Footer from "./Footer";

const Projects = () => {
  return (
    <div className=" bg-[#fff7f1] min-h-screen overflow-hidden">
      <Navbar />
      <div className=" pt-14  " />
      <div className=" flex flex-col items-center">
        <h1 className=" league-spartan-extrabold text-3xl md:text-6xl pt-24 textanime">
          Projects
        </h1>
        <h2 className=" md:text-xl text-gray-400 font-semibold text-sm textanime textanime2">
          Here are some of my projects.
        </h2>
      </div>

      <div className="flex flex-col items-center  md:flex-row md:flex-wrap gap-4 justify-around pt-20 px-4   ">
        <div className="textanime textanime3 relative group bg-white h-fit px-3 md:w-1/3 rounded-3xl flex opacity-70 hover:opacity-100  p-3 hover:-translate-y-2 transition-all hover:cursor-pointer  ">
          <a href="https://astroclublnmiit.vercel.app/" className=" w-fit relative">
            <div className=" flex flex-col items-center  ">
              <h1 className=" league-spartan-medium text-4xl">Astro Site</h1>
              <p className="font-semibold p-3 text-center">
                A project I developed for Plinth Fest at LNMIIT. This site
                showcases my skills in web development, design, and content
                creation, all centered around fostering a community passionate
                about astronomy. The website features a user-friendly interface,
                dynamic event calendars, interactive stargazing guides, and
                educational resources. Through this project, I aimed to create
                an engaging and informative platform that not only highlights
                the club's activities but also inspires a deeper interest in the
                cosmos. Explore the site to see my work in action and discover
                the wonders of our universe!
              </p>

              <div class="absolute top-2 right-2 mt-2 mr-2 text-muted-foreground scale-150 group-hover:scale-[1.5] group-hover:rotate-45 transition-all">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </div>
            </div>
          </a>
          
        </div>
        <div className=" textanime textanime3 relative group bg-white h-fit px-3 md:w-1/3 rounded-3xl flex opacity-70 hover:opacity-100   p-3 hover:-translate-y-2 transition-all hover:cursor-pointer  ">

          <a href="https://whiteboardv2.vercel.app/">
            <div className=" flex flex-col items-center  ">
              <h1 className=" league-spartan-medium text-4xl">
                Collabrative Whiteboard
              </h1>
              <p className="font-semibold p-3 text-center">
                A project I developed to demonstrate my expertise in web
                development and collaborative technologies. This innovative
                platform is designed to facilitate real-time teamwork and
                brainstorming, featuring intuitive drawing tools, seamless file
                sharing integration, and a user-friendly interface that supports
                synchronous collaboration. My goal with this project was to
                create a dynamic and interactive space where students and
                professionals can ideate, plan, and execute projects together
                efficiently. Explore the Collaborative Whiteboard to see my work
                in action and experience the future of digital collaboration.
              </p>

              <div class="absolute top-2 right-2 mt-2 mr-2 text-muted-foreground scale-150 group-hover:scale-[1.5] group-hover:rotate-45 transition-all">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </div>
            </div>
          </a>
        </div>

        <div className="textanime textanime3 relative group bg-white h-fit px-3 md:w-1/3 rounded-3xl flex opacity-70 hover:opacity-150  p-3 hover:-translate-y-2 transition-all hover:cursor-pointer  ">
          <a href="https://todov.cyclic.app/">
            <div className=" flex flex-col items-center  ">
              <h1 className=" league-spartan-medium text-4xl">To-do List</h1>
              <p className="font-semibold p-3 text-center">
                Welcome to the Todo List, a project I developed to showcase my
                skills in web development and productivity tools. This simple
                yet powerful platform is designed to help users organize their
                tasks efficiently and stay on top of their goals. The Todo List
                features a clean and intuitive interface, allowing users to
                easily add, edit, and prioritize tasks. With seamless
                synchronization across devices, users can access their todo
                lists anytime, anywhere. My goal with this project was to create
                a tool that enhances productivity and helps users manage their
                time effectively. Explore the Todo List to see my work in action
                and take control of your daily tasks with ease.
              </p>

              <div class="absolute top-2 right-2 mt-2 mr-2 text-muted-foreground scale-150 group-hover:scale-[1.5] group-hover:rotate-45 transition-all">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="7" y1="17" x2="17" y2="7"></line>
                  <polyline points="7 7 17 7 17 17"></polyline>
                </svg>
              </div>
            </div>
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Projects;
